<template>
    <v-card
      elevation="5"          
      class="text-uppercase pl-10 pr-10 "
      height="400px"
       @keyup.enter="nextWord()"
    >
      <v-card-title class="justify-center white--text">Block</v-card-title>
      <v-card-text v-if="showInterBlock" 
                   style="height: 100%;">
        <v-row>
          <v-col cols="12">
            <h2 class="text-center white--text"> 
                {{block.text[selectedGender].join()}}
            </h2>
          </v-col>
        </v-row>                   
         <v-row   style="height: 100%;">
          <v-col cols="12" class="black--text" >
            <h1>+</h1>
          </v-col>
          <v-col> 
            <h3 :class="{'red--text': showHurryUp, 'white--text': !showHurryUp}" >
              {{hurryUp}}
            </h3>
          </v-col>
         </v-row>
      </v-card-text>
      <v-card-text v-if="!showInterBlock">
        <v-row>
          <v-col cols="12">
            <h2 class="text-center"> 
                {{block.text[selectedGender].join()}}
            </h2>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <h2 class="text-center"> 
                {{targetAdjective[selectedGender]}}
            </h2>
            
             <!-- <h3 >{{output.length}}/{{adjectivesList.length}} -- {{blockFinished}}</h3>
            <h3>{{adjectivesList}}</h3> -->
          </v-col>
        </v-row>
         <v-row class="mt-10">
          <v-col cols="12">
            <v-slider
                v-model="slider"
                thumb-label="always"
                :max="max"
                :min="min"
                v-if="!blockFinished"        
            >                
                <template v-slot:prepend>
                    <span class="text-center">{{min}} <br><span v-html="block.sliderText.min"></span></span>
                </template>
                <template v-slot:append>
                    <span class="text-center">{{max}} <br><span v-html="block.sliderText.max"></span></span>
                </template>
            </v-slider>
            <span v-if="!blockFinished" class="text-center text-center  v-input v-input--is-label-active v-input--is-dirty theme--light v-input__slider v-input__prepend-outer black--text" > 
              Neutral 
            </span>
            <h3 v-if="blockFinished"> Pulsa Siguiente para ver el siguiente bloque</h3>
          </v-col>
        </v-row>
         <v-row>
          <v-col cols="12">
            <v-btn v-if="blockFinished" v-on:click="nextCard()">Siguiente</v-btn>
            <!-- <v-btn v-else v-on:click="nextWord()" >Siguiente</v-btn> -->
          </v-col>
        </v-row>
      </v-card-text>        
    </v-card>        
</template>




<script>
  import * as data from '../../tools/data'
  import { randomBtw, shuffleArray } from '../../tools/helpers'
  import * as api from '../../tools/api'

  export default {
    name: 'BlockValenceCard',
    props:["block"],
    data: () => ({
         slider: 0,
         startValue: 0,
         max: 100,
         min: -100,
         adjective: 0,
         output: [],
         blockFinished: false,
         startTime: 0,
         duration: 0,
         timeOut: null,
         hurryUp: 'Responde más rápido y no olvides presionar la tecla “intro”',
         showHurryUp: false,
         showInterBlock: true,
         ticksLabels:[
          "",
          "Neutral",
          ""
         ]
    }),
    mounted(){      
        window.addEventListener('keyup', this.processKeyPressed)
        console.log(this.block)
        this.activateInterBlock()                         
    },
    beforeDestroy(){
      window.removeEventListener("keyup", this.processKeyPressed)
    },
    methods:{
      activateInterBlock(){
        let duration = this.$store.state.interBlockTimeLimit
        this.showInterBlock = true
        if(this.showHurryUp){
          // console.log(`interblock activated showHurryUp true ${this.showHurryUp}`)
          setTimeout(() => {
            this.showInterBlock = false
            this.startValue = this.slider = randomBtw(this.max,this.min) 
            this.startTime = Date.now()
            clearTimeout(this.timeOut)
            this.setWordTimeOut()
          },duration + this.$store.state.warningTimeLimit + 1000)
          setTimeout(() => {this.showHurryUp = false},this.$store.state.warningTimeLimit)        
        }else{
          // console.log(`interblock activated showHurryUp false ${this.showHurryUp}`)
          setTimeout(() => {
            this.showInterBlock = false
            this.startValue = this.slider = randomBtw(this.max,this.min) 
            this.startTime = Date.now()
            clearTimeout(this.timeOut)
            this.setWordTimeOut()
          },duration)
        }
      },
      processKeyPressed(event){
        if(event.keyCode == 13 && !this.blockFinished)   
          this.nextWord()    
      },     
      nextCard(){
        this.$store.dispatch('nextCard')
      },
      async nextWord(){
         this.output.push({
                "target": this.targetAdjective.id,
                "session": this.$store.state.sessionId,
                "serie": this.$store.state.serie,
                "block": this.block.blockId,
                "user_id": this.$store.state.userData.id,
                "user_code": this.$store.state.userId,
                "initial_score": this.startValue,
                "selected_score": this.slider,
                "duration": Date.now() - this.startTime                
            })
        
        if (this.output.length == this.adjectivesList.length){
            this.$store.dispatch('addBlockResults',this.output)
            let results = await api.insertResults(this.$store.state.apiUri,this.output)
            this.blockFinished = true
        }else{
            this.activateInterBlock()
            this.adjective++            
        }
      },      
      setWordTimeOut() {
        let wordDuration = this.$store.state.timeLimit
        let warningDuration = this.$store.state.warningTimeLimit
        this.timeOut = setTimeout(() => {
          if(!this.blockFinished){
            this.showHurryUp = true
            this.nextWord()            
            // setTimeout(() => {this.showHurryUp = false},2000)
          }
        }, wordDuration);
      },
    },
    computed:{
      adjectivesList(){
        // return shuffleArray(data.adjectives.slice(0 ,10))
        return shuffleArray(data.adjectives)
      },      
      selectedGender(){
        let genderId = this.$store.state.genderId
        if(genderId == 1)
            return 'female' 
        else if (genderId == 2)
            return 'male'
      },
      targetAdjective(){
        return this.adjectivesList[this.adjective]
      }
    }
  }
</script>
